import React, { useState } from "react";
import Steps from "../../Steps";
import Button from "../../../../common/Button";
import ChartNav from "../../../../common/ChartNav";
import Medications from "../../medications/medications";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import { useEffect } from "react";
import {
  createMedication,
  deleteMedication,
  updateClinicalService,
  updateMedication,
} from "../../../../../redux/modules/clinical-services/actions";
import { ReactSVG } from "react-svg";
import NewToolTip from "../../../../common/New-ToolTip";
import NonPharmacologicalToolTip from "../../../../common/tooltip/minor-ailments/non-pharmacological";
import { nonPharmacologicalCards } from "./non-pharmacological/data";
import NonPharmacologicalCard from "./non-pharmacological/non-pharmacological-card";
import MedicationCreate from "../clinical-assessment/MedicationCreate";
import SubNavigation from "../../common/sub-navigation";
import MyResults from "../other/my-results";
import { getValidStep } from "../../../text/data";
import { drugTypes } from "../clinical-assessment/data";

const NonPharmacological = () => {
  const { clinicalServiceObj, clinicalServiceSteps } = useSelector((state) => state.clinicalService);
  const dispatch = useDispatch();
  const { id: patientId, serviceId } = useParams();
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const { frequencyOfSymptoms, levelOfSeverity } =
    clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment;
  const [showMedicationSlider, setShowMedicationSlider] = useState(false);
  const [clickedMedication, setClickedMedication] = useState(null);
  const [subMedicationType, setSubMedicationType] = useState("");
  const [nasalSalineRinsePrescription, setNasalSalineRinsePrescription] =
    useState({});
  const [nasalSalineSprayPrescription, setNasalSalineSprayPrescription] =
    useState({});
  const [nasalLubricantPrescription, setNasalLubricantPrescription] = useState(
    {}
  );
  const [isCreate, setIsCreate] = useState(true);
  const [deleteMedicationPopup, setDeleteMedicationPopup] = useState(false);
  const { showReferral } =
  clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [showRef, setShowRef] = useState(showReferral ?? false);

  const getPrescription = async () => {

    let medicationsToSave = [];
    if (nasalSalineRinsePrescription?.medicationName) {
      medicationsToSave.push(nasalSalineRinsePrescription);
    }
    if (nasalSalineSprayPrescription?.medicationName) {
      medicationsToSave.push(nasalSalineSprayPrescription);
    }
    if (nasalLubricantPrescription?.medicationName) {
      medicationsToSave.push(nasalLubricantPrescription);
    }
    const medicinesToCreate = medicationsToSave.filter((med) => !med.id);
    const medicinesToUpdate = medicationsToSave.filter((med) => med.id);
    let createdMedications = {};
    let updatedMedications = {};
    if (medicinesToCreate.length > 0) {
      createdMedications = await dispatch(
        createMedication(patientId, {
          medications: medicinesToCreate,
        })
      );
    }
    if (medicinesToUpdate.length > 0) {
      updatedMedications = await dispatch(
        updateMedication(patientId, {
          medications: medicinesToUpdate,
        })
      );
    }
    let allMedications = [
      ...(updatedMedications?.medications ?? []),
      ...(createdMedications?.medications ?? []),
    ];
    const findNasalSalineRinsePrescription = allMedications.find(
      (med) =>
        med.medicationName === nasalSalineRinsePrescription?.medicationName
    );
    const findNasalSalineSprayPrescription = allMedications.find(
      (med) =>
        med.medicationName === nasalSalineSprayPrescription?.medicationName
    );
    const findNasalLubricantPrescription = allMedications.find(
      (med) =>
        med.medicationName === nasalLubricantPrescription?.medicationName
    );

    let prescriptions = {
      nasalSalineRinsePrescriptions:
        nasalSalineRinsePrescription?.medicationName
          ? [findNasalSalineRinsePrescription]
          : [],
      nasalSalineSprayPrescriptions:
        nasalSalineSprayPrescription?.medicationName
          ? [findNasalSalineSprayPrescription]
          : [],
      nasalLubricantPrescriptions:
        nasalLubricantPrescription?.medicationName
          ? [findNasalLubricantPrescription]
          : [],
    };

    return prescriptions;
  };

  const onNext = async () => {
    if (currentStep <= clinicalServiceSteps.length) {
      const { nextStep, nextSubStep } = getValidStep(clinicalServiceSteps, currentStep, currentSubStep, 1);

      let prescriptions = await getPrescription();
      const updatedSteps = {
        treatment: prescriptions,
        currentStep: nextStep,
        currentSubStep: nextSubStep,
        showReferral: showRef,
        serviceSteps: clinicalServiceSteps
      };
      dispatch(updateClinicalService(serviceId, updatedSteps));
    }
  };

  const onPrevious = async () => {
    const { nextStep, nextSubStep } = getValidStep(clinicalServiceSteps, currentStep, currentSubStep, -1);
    
    let prescriptions = await getPrescription();
    const updatedSteps = {
      treatment: prescriptions,
      currentStep: nextStep,
      currentSubStep: nextSubStep,
      showReferral: showRef,
    };
    dispatch(updateClinicalService(serviceId, updatedSteps));
  };

  useEffect(() => {
    if (
      clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment
    ) {
      let treatment =
        clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment;
      if (treatment?.nasalSalineRinsePrescriptions?.length > 0) {
        setNasalSalineRinsePrescription(
          treatment?.nasalSalineRinsePrescriptions[0]
        );
        setNasalSalineSprayPrescription(
          treatment?.nasalSalineSprayPrescriptions[0]
        );
        setNasalLubricantPrescription(
          treatment?.nasalLubricantPrescriptions[0]
        );
      }
    }
  }, [clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment]);

  const customSubmit = (medication, type) => {
    if (type === "nasalSalineRinses") {
      setNasalSalineRinsePrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
    } else if (type === "nasalSalineSprays") {
      setNasalSalineSprayPrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
    } else if (type === "nasalLubricants") {
      setNasalLubricantPrescription(medication.medications[0]);
      setClickedMedication(null);
      setShowMedicationSlider(false);
    }
  };

  const handlePrescribedMedication = (type) => {
    if (type === "nasalSalineRinses") {
      return nasalSalineRinsePrescription;
    } else if (type === "nasalSalineSprays") {
      return nasalSalineSprayPrescription;
    } else if (type === "nasalLubricants") {
      return nasalLubricantPrescription;
    }
  };

  const deleteMedicationConfirmAction = (type) => {
    setDeleteMedicationPopup(false);
    setClickedMedication(null);
    setShowMedicationSlider(false);
    if (type === "nasalSalineRinses") {
      dispatch(deleteMedication(nasalSalineRinsePrescription.id));
      setNasalSalineRinsePrescription({});
    } else if (type === "nasalSalineSprays") {
      dispatch(deleteMedication(nasalSalineSprayPrescription.id));
      setNasalSalineSprayPrescription({});
    } else if (type === "nasalLubricants") {
      setNasalLubricantPrescription({});
      dispatch(deleteMedication(nasalLubricantPrescription.id));
    }
  };

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications defaultExpandedSection="prescribedRx" />
          <div className="flex flex-1 w-full h-[668px] overflow-y-auto scroll-smooth ">
            <div className="w-full gap-5">
              <div className="flex items-center justify-between mt-0.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  Non-Pharmacological Treatment
                  <ReactSVG
                    src="/icons/information-dark.svg"
                    className="w-5 h-5 ml-3  inline-block"
                    data-tooltip-id="non-pharmacological-treatment"
                  />
                  <NewToolTip
                    id="non-pharmacological-treatment"
                    render={() => <NonPharmacologicalToolTip />}
                  />
                </h4>
                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div className="flex flex-col ">
                <div className="flex justify-between">
                <MyResults frequencyOfSymptoms={frequencyOfSymptoms} levelOfSeverity={levelOfSeverity}/>
                </div>
                <div
                  className="grid grid-flow-col gap-6 scroll-smooth mt-6 auto-cols-[540px]  overflow-auto "
                  id="nonPharmacological"
                >
                  {nonPharmacologicalCards.map((nonPharmacological, index) => {
                    return (
                      <NonPharmacologicalCard
                        key={index}
                        data={nonPharmacological}
                        onAddClick={() => {
                          setShowMedicationSlider(true);
                          setSubMedicationType(nonPharmacological.type);
                          setIsCreate(true);
                        }}
                        prescribedMedication={handlePrescribedMedication(
                          nonPharmacological.type
                        )}
                        onEditClick={(medication) => {
                          setClickedMedication(medication);
                          setShowMedicationSlider(true);
                          setSubMedicationType(nonPharmacological.type);
                          setIsCreate(false);
                        }}
                        onDeleteClick={(medication) => {
                          setSubMedicationType(nonPharmacological.type);
                          setClickedMedication(medication);
                          setDeleteMedicationPopup(true);
                        }}
                      />
                    );
                  })}
                </div>
                <MedicationCreate
                  isRxService={true}
                  isMATreatment={true}
                  create={isCreate}
                  patientId={patientId}
                  type="Medication"
                  subType={subMedicationType}
                  open={showMedicationSlider}
                  fullMedication={clickedMedication}
                  step={1}
                  maxSteps={1}
                  onClose={(value) => {
                    setClickedMedication(null);
                    setShowMedicationSlider(value);
                  }}
                  onSave={() => {
                    setShowMedicationSlider(false);
                  }}
                  customSubmit={true}
                  customSubmitAction={(medication, type) => {
                    customSubmit(medication, type);
                  }}
                  showDispenseQtyAndRefills={true}
                  selectedDrugType={drugTypes.PrescribedRx}
                />
                <ConfirmationModalNew
                  type="primary"
                  title="Delete Prescription"
                  content={() => (
                    <div className="flex flex-col gap-4">
                      <p className="text-body-md text-gray-600 font-medium">
                        Are you sure you want to delete{" "}
                        <span className="font-semibold">
                          {clickedMedication?.medicationName}?
                        </span>
                      </p>
                      <p className="text-body-sm text-gray-600">
                        This will permantently delete the prescription.
                      </p>
                    </div>
                  )}
                  confirmText={"Delete"}
                  confirmAction={() => {
                    deleteMedicationConfirmAction(subMedicationType);
                  }}
                  open={deleteMedicationPopup}
                  handleClose={() => {
                    setDeleteMedicationPopup(false);
                  }}
                  onCross={() => {
                    setDeleteMedicationPopup(false);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between space-x-4 rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => {
              onPrevious();
            }}
          />
          <Button
            type="primary"
            text="Next"
            className={`w-[200px] max-h-[52px] !rounded-[30px] `}
            onClick={() => {
              onNext();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NonPharmacological;
